import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicLayout from "../components/PublicLayout";
import { ArticleCard, ArticleListItem } from "../components/ArticleCard";
import { PopularSidebar } from "../components/Sidebars";
import AdSlot from "../components/AdSlot";
import api from "../lib/api";

export default function HomePage() {
  const [featured, setFeatured] = useState([]);
  const [latest, setLatest] = useState([]);
  const [byCategory, setByCategory] = useState({});
  const [categories, setCategories] = useState([]);
  const [heroBanner, setHeroBanner] = useState(null);

  useEffect(() => {
    api.get("/articles", { params: { featured: true, limit: 6 } }).then(r => setFeatured(r.data.items || []));
    api.get("/articles", { params: { limit: 8 } }).then(r => setLatest(r.data.items || []));
    api.get("/categories").then(async (r) => {
      const cats = r.data || [];
      setCategories(cats);
      const map = {};
      await Promise.all(cats.slice(0, 4).map(async (c) => {
        const res = await api.get("/articles", { params: { category: c.slug, limit: 4 } });
        map[c.slug] = res.data.items || [];
      }));
      setByCategory(map);
    });
    api.get("/banners", { params: { position: "hero", active: true } }).then(r => setHeroBanner((r.data || [])[0])).catch(() => {});
  }, []);

  const hero = featured[0];
  const sec1 = featured.slice(1, 4);
  const sec2 = featured.slice(4, 6);

  return (
    <PublicLayout>
      <div className="max-w-7xl mx-auto px-4 py-6" data-testid="home-page">
        {/* hero section */}
        {hero ? (
          <section className="grid lg:grid-cols-3 gap-8 mb-12">
            <div className="lg:col-span-2 border-b border-zinc-300 pb-8 lg:border-b-0 lg:border-r lg:pr-8">
              <ArticleCard article={hero} size="hero" />
            </div>
            <div className="space-y-6">
              {sec1.map(a => <div key={a.id} className="border-b border-zinc-200 pb-6 last:border-b-0"><ArticleCard article={a} size="md" showImage={false} /></div>)}
            </div>
          </section>
        ) : (
          <section className="text-center py-12 border border-zinc-300 mb-12" data-testid="empty-state">
            <h2 className="font-serif-display text-3xl font-semibold">Edição em preparo</h2>
            <p className="font-body text-zinc-600 mt-2">Nenhuma notícia publicada ainda. Acesse o <Link to="/admin/login" className="underline text-red-700">painel administrativo</Link> para começar.</p>
          </section>
        )}

        {/* hero banner */}
        {heroBanner && (
          <a href={heroBanner.link || "#"} className="block mb-12" target={heroBanner.link ? "_blank" : "_self"} rel="noopener noreferrer" data-testid="hero-banner">
            <img src={heroBanner.image} alt={heroBanner.title} className="w-full" />
          </a>
        )}

        {/* destaques secundários */}
        {sec2.length > 0 && (
          <section className="mb-12">
            <div className="hairline-accent pt-3 mb-6 flex items-baseline justify-between">
              <h2 className="font-serif-display text-2xl font-bold">Destaques</h2>
              <Link to="/destaques" className="overline text-zinc-500 hover:text-black">Ver todos →</Link>
            </div>
            <div className="grid md:grid-cols-2 gap-8">
              {sec2.map(a => <ArticleCard key={a.id} article={a} size="lg" />)}
            </div>
          </section>
        )}

        {/* últimas + sidebar */}
        <section className="grid lg:grid-cols-3 gap-8 mb-12">
          <div className="lg:col-span-2">
            <div className="hairline-accent pt-3 mb-6 flex items-baseline justify-between">
              <h2 className="font-serif-display text-2xl font-bold">Últimas Notícias</h2>
              <Link to="/ultimas" className="overline text-zinc-500 hover:text-black">Ver todas →</Link>
            </div>
            <div className="grid sm:grid-cols-2 gap-6">
              {latest.slice(0, 6).map(a => <ArticleCard key={a.id} article={a} size="md" />)}
            </div>
          </div>
          <aside className="space-y-8">
            <PopularSidebar />
            <AdSlot placement="sidebar" />
          </aside>
        </section>

        {/* by category sections */}
        {categories.slice(0, 4).map(c => {
          const arts = byCategory[c.slug] || [];
          if (!arts.length) return null;
          return (
            <section key={c.id} className="mb-12" data-testid={`section-${c.slug}`}>
              <div className="hairline-accent pt-3 mb-6 flex items-baseline justify-between">
                <h2 className="font-serif-display text-2xl font-bold">{c.name}</h2>
                <Link to={`/categoria/${c.slug}`} className="overline text-zinc-500 hover:text-black">Ver tudo →</Link>
              </div>
              <div className="grid md:grid-cols-4 gap-6">
                {arts.map(a => <ArticleCard key={a.id} article={a} size="md" />)}
              </div>
            </section>
          );
        })}

        <AdSlot placement="inline" />
      </div>
    </PublicLayout>
  );
}
